module.exports = __webpack_public_path__ + "static/img/13.6cbc8e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/_20240801/13.png
// module id = QyKL
// module chunks = 0